"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SavedPaymentCard = SavedPaymentCard;
var _react = _interopRequireDefault(require("react"));
var _elements = require("@reservamos/elements");
var _reactI18next = require("react-i18next");
var _cardGradient = require("./cardGradient");
function classNames() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  return values.filter(Boolean).join(' ');
}

/** Faithful TypeScript/Tailwind port of the saved-payment-card used by CON-760. */
function SavedPaymentCard(_ref) {
  var card = _ref.card,
    deleteDisabled = _ref.deleteDisabled,
    _ref$idPrefix = _ref.idPrefix,
    idPrefix = _ref$idPrefix === void 0 ? 'bt-saved-card' : _ref$idPrefix,
    isActive = _ref.isActive,
    onCloseDeleteMode = _ref.onCloseDeleteMode,
    onConfirmDelete = _ref.onConfirmDelete,
    onOpenDeleteMode = _ref.onOpenDeleteMode,
    onSelect = _ref.onSelect,
    toDelete = _ref.toDelete;
  var _useTranslation = (0, _reactI18next.useTranslation)('purchase'),
    t = _useTranslation.t;
  var _useTranslation2 = (0, _reactI18next.useTranslation)('payment'),
    tPayment = _useTranslation2.t;
  var typeTranslated = tPayment(card.cardType === 'debit' ? 'saved_card.type_debit' : 'saved_card.type_credit');
  var brandLabel = (0, _cardGradient.getCardBrandLabel)(card.brand);
  var title = card.brand ? tPayment('saved_card.title', {
    brand: brandLabel,
    type: typeTranslated
  }) : typeTranslated;
  var unavailable = card.isExpired || card.paymentMode.kind === 'unavailable';
  var checked = isActive && !unavailable;
  var shouldShowInstallmentsLabel = card.installmentsAvailable && !unavailable;
  var gradient = unavailable ? 'bg-gray-200' : (0, _cardGradient.getCardGradient)(card.cardType, card.brand);
  var cardBrand = (0, _cardGradient.normalizeCardBrand)(card.brand);
  var shellTone = toDelete ? 'border-error-strong bg-error-strong' : checked ? 'border-success-regular bg-success-regular/10' : 'border-gray-100 bg-gray-100';
  function selectCard() {
    if (!unavailable && !toDelete) onSelect();
  }
  function handlePanelKeyDown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    selectCard();
  }
  function handleTrashClick(event) {
    event.stopPropagation();
    if (deleteDisabled) return;
    if (toDelete) onConfirmDelete();else onOpenDeleteMode();
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "saved-payment-card-".concat(card.id),
    "data-selected": checked ? 'true' : 'false',
    className: classNames('flex w-full flex-col overflow-hidden rounded-xl border border-solid transition-all duration-500 ease-out hover:shadow-md md:flex-row md:items-center', unavailable ? 'cursor-not-allowed' : 'cursor-pointer', shellTone),
    "data-sentry-component": "SavedPaymentCard",
    "data-sentry-source-file": "SavedPaymentCard.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames('flex w-full items-center justify-between rounded-xl shadow-md transition-[padding] duration-500 ease-out md:flex-1 md:shadow-none', unavailable || toDelete ? 'pl-0' : 'pl-2')
  }, !unavailable && /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "".concat(idPrefix, "-").concat(card.id),
    "aria-hidden": toDelete,
    className: classNames('relative flex flex-shrink-0 items-center justify-center overflow-hidden transition-all duration-500 ease-out', toDelete ? 'max-w-0 opacity-0' : 'w-10 max-w-10 opacity-100')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: classNames('-mr-[15px] flex', checked ? 'opacity-0' : 'opacity-100')
  }, /*#__PURE__*/_react["default"].createElement(_elements.InputRadio, {
    name: "bt-saved-cards",
    value: card.id,
    isActive: checked,
    onChange: selectCard,
    onClick: checked ? selectCard : undefined,
    id: "".concat(idPrefix, "-").concat(card.id),
    isDisabled: unavailable,
    interior: checked,
    color: "success"
  })), checked && /*#__PURE__*/_react["default"].createElement("span", {
    className: "absolute inset-0 flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex scale-[0.84] items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    type: "Success",
    color: "success",
    size: "M"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: unavailable ? -1 : 0,
    onClick: selectCard,
    onKeyDown: handlePanelKeyDown,
    className: classNames('flex min-h-[66px] flex-1 items-center justify-between rounded-xl px-2 py-3 shadow-sm md:px-5', unavailable ? 'cursor-default' : 'cursor-pointer', gradient)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-w-0 flex-1 items-center gap-1 md:gap-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-white p-2"
  }, /*#__PURE__*/_react["default"].createElement(_elements.CreditCardIcon, {
    cardBrand: cardBrand,
    hasMargin: false,
    hideBorder: true,
    "data-sentry-element": "CreditCardIcon",
    "data-sentry-source-file": "SavedPaymentCard.tsx"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 flex-1"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S",
    color: unavailable ? 'grayStrong' : 'white',
    weight: "bold",
    mobileSize: "XS",
    maxWidthEllipsis: 150,
    mobileMaxWidthEllipsis: 100,
    "data-sentry-element": "Text",
    "data-sentry-source-file": "SavedPaymentCard.tsx"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "capitalize"
  }, title)), /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S",
    color: unavailable ? 'grayMedium' : 'white',
    mobileSize: "XS",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "SavedPaymentCard.tsx"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "md:hidden"
  }, "**** ", card.last4), /*#__PURE__*/_react["default"].createElement("span", {
    className: "hidden md:inline"
  }, "**** **** **** ", card.last4)), shouldShowInstallmentsLabel && /*#__PURE__*/_react["default"].createElement("span", {
    className: "block md:hidden"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "XXS",
    color: "white",
    weight: "semibold"
  }, t('saved_card.installments_available_short'))))), shouldShowInstallmentsLabel && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-2 hidden min-w-0 max-w-56 flex-1 justify-center md:flex"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "XS",
    color: "white",
    weight: "semibold",
    mobileSize: "XXS",
    maxWidthEllipsis: 220
  }, t('saved_card.installments_available'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-2 flex flex-shrink-0 items-center gap-2"
  }, unavailable ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex max-w-44 items-center gap-1.5 rounded-full bg-error-strong px-2 py-1",
    role: "status"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    type: "Warning",
    color: "white",
    size: "S"
  }), /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "XS",
    color: "white",
    weight: "semibold"
  }, card.isExpired ? t('saved_card.expired_on') : t('saved_card.unavailable'))) : /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": toDelete,
    className: classNames('overflow-hidden transition-[max-width,opacity] duration-300 ease-in-out', toDelete ? 'max-w-0 opacity-0' : 'max-w-32 opacity-100 delay-300')
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "XS",
    color: "white",
    textAlign: "right",
    mobileSize: "XXS"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "md:hidden"
  }, t('saved_card.expiration_short')), /*#__PURE__*/_react["default"].createElement("span", {
    className: "hidden md:inline"
  }, t('saved_card.expiration'))), /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S",
    color: "white",
    weight: "semibold",
    textAlign: "right",
    mobileSize: "XXS"
  }, card.expirationLabel)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames('flex items-center overflow-hidden transition-all duration-500 ease-in-out', toDelete ? 'max-w-14 opacity-100' : 'pointer-events-none max-w-0 opacity-0'),
    "aria-hidden": !toDelete
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    tabIndex: toDelete ? 0 : -1,
    onClick: function onClick(event) {
      event.stopPropagation();
      onCloseDeleteMode();
    },
    "aria-label": t('saved_card.close_delete_mode_aria'),
    "aria-expanded": toDelete,
    className: "flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-sm hover:bg-gray-200 focus:outline-none"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    size: "S",
    mobileSize: "XS",
    type: "ChevronRight",
    color: "grayMedium",
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "SavedPaymentCard.tsx"
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-shrink-0 self-stretch"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: handleTrashClick,
    disabled: deleteDisabled,
    "aria-label": t(toDelete ? 'saved_card.confirm_delete_aria' : 'saved_card.delete_card_aria'),
    "aria-expanded": toDelete,
    className: classNames('flex h-full min-w-11 items-center justify-center transition-all duration-500 ease-in-out', toDelete ? 'bg-error-strong px-3' : 'px-0 hover:bg-gray-200', deleteDisabled ? 'cursor-not-allowed opacity-50' : '')
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    size: "M",
    type: "Trash",
    color: toDelete ? 'white' : 'grayLight',
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "SavedPaymentCard.tsx"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": !toDelete,
    className: classNames('overflow-hidden transition-[max-width,opacity,margin-left] duration-500 ease-in-out', toDelete ? 'ml-2 max-w-32 opacity-100 delay-300' : 'ml-0 max-w-0 opacity-0')
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    color: "white",
    size: "S",
    mobileSize: "XS",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "SavedPaymentCard.tsx"
  }, t('saved_card.delete')))))));
}